import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import ModalDocumentManagement from "./ModalDocumentManagement";
import Tooltip from '@material-ui/core/Tooltip';
import AlertModal from '../../../../shared/components/Modal';

const ListDocumentsActions = ({ data, id_estudio, refreshList, toggle }) => {
    const history = useHistory();
    const doc = data.data.original;
    const [openModal, setOpenModal] = React.useState(false);

    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);
    const [errorModalAD, setErrorModalAD] = React.useState(false);

    useEffect(() => {

    }, []);

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const showFile = () => {
        let url = `${process.env.REACT_APP_PUBLIC_URL}gestion-documental/${id_estudio}/${doc.archivo}/${sessionStorage.getItem('token')}`;
        window.open(url, '_blank');
    }

    const deleteDocument = async () => {

        let dataDoc =
        {
            id_est_gestd: doc.id_est_gestd
        }

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}gestion-documental/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataDoc)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                refreshList();
            }
            else {
                alert("Ha ocurrido un error en el Servidor");
            }
        }).catch(err => {
        });
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Ver Archivo">
                <IconButton style={{ fontSize: '15px' }} onClick={() => showFile()}>
                    <FontAwesomeIcon icon={faFileAlt} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Actualizar Documento">
                <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Documento">
                <IconButton style={{ fontSize: '15px' }} onClick={() => {
                    if (doc.estado == 2) {
                        setDeleteModal(true)
                    }
                    else {
                        setErrorModalAD(true);
                    }
                }
                }>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>

        <ModalDocumentManagement
            openModal={openModal}
            closeModal={() => setOpenModal(false)}
            id_estudio={id_estudio}
            listarDocumentos={refreshList}
            documentInformation={doc}
            toggle={toggle}
        />

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar este requerimiento?"
            modal={showDeleteModal}
            onOk={() => deleteDocument()}
            toggle={() => setDeleteModal(false)}
        />

        <AlertModal
            color="success"
            title="Requerimiento eliminado correctamente"
            modal={successModal}
            onOk={() => {
                setSuccessModal(false);
                setOpenModal(false);
            }}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar el Requerimiento"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />

        <AlertModal
            color="danger"
            title="No puede eliminar un documento activo"
            modal={errorModalAD}
            onOk={() => setErrorModalAD(false)}
            toggle={() => setErrorModalAD(false)}
        />
    </Fragment>)
}

export default ListDocumentsActions;